import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// components
import LoadingScreen from '../components/LoadingScreen';
import { adminRoles } from 'src/helpers/constants';

// ----------------------------------------------------------------------

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const { pathname } = useLocation();
  const activeEvent = localStorage.getItem('arsh:activeevent');

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if ((!isAuthenticated || !user) && pathname.includes('client/app')) {
    return <Navigate to={`/client/login`} />;
  }

  if (!isAuthenticated || !user) {
    if (activeEvent) {
      return <Navigate to={`/${activeEvent}/login?returnURL=${window.location.href}`} />;
    }
    const urlPath = window.location.pathname;
    const segments = urlPath.split('/');
    const extractedWord = segments[1];

    return <Navigate to={`/${extractedWord}/login?returnURL=${window.location.href}`} />;
  }

  if (isAuthenticated && pathname.includes('returned=true')) {
    const returnURL = pathname.split('return=/')[0];
    console.log(returnURL, pathname);
    return <Navigate to={returnURL} />;
  }

  // Security Guard: Prevent non-admin users from accessing /admin routes
  if (pathname.includes('/admin')) {
    if (user?.userType !== 'admin') {
      if (user?.userType === 'exhibitor') {
        return <Navigate to={`/exhibitor-dashboard/home`} />;
      }
      if (user?.userType === 'delegate') {
        if (activeEvent) {
          return <Navigate to={`/${activeEvent}/event`} />;
        }
        return <Navigate to="/" />;
      }
      if (user?.userType === 'speaker') {
        if (activeEvent) {
          return <Navigate to={`/${activeEvent}/speaker-dashboard`} />;
        }
        return <Navigate to="/" />;
      }
      if (user?.userType === 'client') {
        return <Navigate to={`/client/app`} />;
      }
      return <Navigate to={`/${activeEvent || ''}/login`} />;
    }

    if (pathname.includes('dashboard')) {
      const role = adminRoles.find((r) => r.title?.toLowerCase() === user?.role?.toLowerCase());
      const roleId = role ? role.id : 999;
      if (roleId > 2) {
        return <Navigate to={`/admin/exhibitors/view-exhibitors`} />;
      }
    }
  }

  // Security Guard: Prevent admin/speaker/exhibitor from landing on attendee event lobby (/:event/event)
  const isAttendeeEventRoute = /\/[^/]+\/event(\/|$)/.test(pathname);
  if (isAttendeeEventRoute && !pathname.includes('/admin') && !pathname.includes('/client')) {
    if (user?.userType === 'admin') {
      return <Navigate to={`/admin`} />;
    }
    if (user?.userType === 'speaker') {
      if (activeEvent) {
        return <Navigate to={`/${activeEvent}/speaker-dashboard`} />;
      }
      return <Navigate to="/" />;
    }
    if (user?.userType === 'exhibitor') {
      return <Navigate to={`/exhibitor-dashboard/home`} />;
    }
  }

  return <>{children}</>;
}

